import React,{ Component } from 'react';
import 'babel-polyfill';
import './App.css';
import Routes from './routes';

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            Stop:'',
        };
    }


    componentDidMount=function() {
        // window.onscroll = function() {
        //     //为了保证兼容性，这里取两个值，哪个有值取哪一个
        //     // scrollTop就是触发滚轮事件时滚轮的高度
        //     let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //     console.log("滚动距离" + scrollTop);
        // }
    };
    componentWillUnmount=function() {
        this.setState = (state,callback)=>{};
    };
    BackTopClick=()=>{
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth',
        });
    };




    render() {
        const auth = this.props;
        return (
            <div className={'App'}>
                <Routes auth={auth}/>
                {/*<div className={'BackTop'} onClick={this.BackTopClick.bind(this)}> </div>*/}
            </div>
        );
    }
}

export default App;
